import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { catLabel } from "../../lib/api";

export const halves = (t = "") => {
  const w = t.split(" ");
  const cut = Math.max(1, Math.floor(w.length / 2));
  return [w.slice(0, cut).join(" "), w.slice(cut).join(" ")];
};

// The printed "type page": headline split above and below the photo, small mono lines in between.
export const FeatureSpread = ({ a }) => {
  if (!a) return null;
  const [top, bottom] = halves(a.title);
  return (
    <section className="bg-paper border-y border-ink py-12 sm:py-20" data-testid="feature-spread">
      <Link to={`/article/${a.slug}`} className="group block max-w-[1440px] mx-auto px-5 sm:px-10" aria-label={a.title}>
        <Reveal>
          <h2 className="dz-type text-[clamp(2.4rem,6vw,6.5rem)]" data-testid="feature-title">{top}</h2>
        </Reveal>
        <div className="grid lg:grid-cols-12 gap-6 my-8 sm:my-10">
          <div className="lg:col-span-3 flex flex-col justify-between gap-4 order-2 lg:order-1">
            <span className="kicker">Feature · {catLabel(a.category)}</span>
            {a.dek && <p className="font-serif text-lg sm:text-xl leading-snug">{a.dek}</p>}
            <span className="kicker inline-flex items-center gap-2 group-hover:text-pink transition-colors" data-testid="feature-read-btn">
              Read the feature <ArrowRight className="h-4 w-4 group-hover:translate-x-1.5 transition-transform" />
            </span>
          </div>
          <div className="lg:col-span-9 order-1 lg:order-2 overflow-hidden">
            <img src={a.cover} alt={a.title} loading="lazy" className="w-full aspect-[4/5] sm:aspect-[16/10] object-cover object-top transition-transform duration-700 group-hover:scale-[1.02]" />
          </div>
        </div>
        <Reveal>
          <p className="dz-type text-[clamp(2.4rem,6vw,6.5rem)] text-right">{bottom}</p>
        </Reveal>
      </Link>
    </section>
  );
};
